import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BackLinkProps {
  to: string;
  label: string;
  className?: string;
}

export const BackLink: React.FC<BackLinkProps> = ({ to, label, className = 'mb-6' }) => {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 hover:opacity-70 ${className}`}
      style={{
        fontFamily: 'Oxygen',
        fontSize: '14px',
        color: '#667085',
      }}
    >
      <ArrowLeft size={20} color="#667085" strokeWidth={1.67} aria-hidden="true" />
      {label}
    </Link>
  );
};

export default BackLink;

